var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.372,
    height: 27.365,
    viewBox: "0 0 27.372 27.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(-4320.933 -2185.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M4348.305,2192.363c-.035.247-.065.5-.107.743a6.623,6.623,0,0,1-1.8,3.541c-.828.856-1.678,1.691-2.524,2.53a1.229,1.229,0,0,1-1.3.328,1.212,1.212,0,0,1-.88-.973,1.244,1.244,0,0,1,.369-1.173c.371-.373.745-.743,1.115-1.117.517-.522,1.065-1.019,1.542-1.576a4.268,4.268,0,0,0-2.465-6.942,4.123,4.123,0,0,0-3.825,1.178q-2.585,2.55-5.135,5.132a4.248,4.248,0,0,0,.667,6.57,1.322,1.322,0,0,1,.535,1.65,1.277,1.277,0,0,1-1.884.537,6.426,6.426,0,0,1-2.6-3.108,6.6,6.6,0,0,1,1.4-7.376c1.737-1.84,3.558-3.6,5.367-5.373a6.476,6.476,0,0,1,3.857-1.809l.4-.051h.866a.582.582,0,0,0,.093.022,6.085,6.085,0,0,1,1.74.371,6.776,6.776,0,0,1,4.42,5.082c.072.311.1.632.142.948Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M4339.756,2200.655a6.538,6.538,0,0,1-1.892,4.522q-2.661,2.718-5.382,5.38a6.5,6.5,0,0,1-3.89,1.834,6.826,6.826,0,0,1-7.531-5.519,6.615,6.615,0,0,1,1.767-5.984c.822-.875,1.689-1.708,2.542-2.553a1.226,1.226,0,0,1,1.3-.319,1.213,1.213,0,0,1,.869.968,1.26,1.26,0,0,1-.385,1.194q-1.167,1.164-2.33,2.331a5.38,5.38,0,0,0-.436.49,4.275,4.275,0,0,0,2.439,6.763,4.073,4.073,0,0,0,3.914-1.087q2.656-2.595,5.252-5.253a4.251,4.251,0,0,0-.718-6.512,1.293,1.293,0,0,1-.647-1.063,1.28,1.28,0,0,1,1.98-1.129,6.722,6.722,0,0,1,1.73,1.586A6.974,6.974,0,0,1,4339.756,2200.655Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkCopy);
export default __webpack_public_path__ + "static/media/linkCopy.61a34ba593fba1fc20b391d452cf19f6.svg";
export { ForwardRef as ReactComponent };